import React, { useState } from 'react';
import { Input } from 'zarm';
import { InputProps } from '../type.d';

const InputWidget = (props: InputProps) => {
  const { options, _crengine, onChange, defaultValueList, valueList: pVal } = props;

  const [value, setValue] = useState<any>(pVal || defaultValueList || []);

  const onComponentChange = (item: any) => {
    let isExitIndex = -1;

    if (value && Array.isArray(value)) {
      if (value.length === 0) {
        value.push(item);
      } else {
        value.forEach((val, index) => {
          if (val.name === item.name) {
            isExitIndex = index;
          }
        });

        if (isExitIndex === -1) {
          value.push(item);
        } else {
          value.splice(isExitIndex, 1, item);
        }
      }

      setValue(value);
      onChange && onChange(value);
    }
  };

  const bindData = item => {
    const { value: bVal, defaultValueList } = props;
    if (bVal && Array.isArray(bVal) && bVal.length) {
      bVal.forEach(bItem => {
        if (bItem.name === (item.name || item.dataBind)) {
          item.defaultValue = bItem.value;
        }
      });
    } else if (defaultValueList && Array.isArray(defaultValueList) && defaultValueList.length) {
      defaultValueList.forEach(bItem => {
        if (bItem.name === (item.name || item.dataBind)) {
          item.defaultValue = bItem.value;
        }
      });
    }
    return item;
  };

  return (
    <div>
      {options &&
        Array.isArray(options) &&
        options.length > 0 &&
        options.map((item) => {
          const { label, dataBind, defaultValue, ...rest } = bindData(item);
          return (
            <div>
              {label && <div className="group-textarea-label">{label}</div>}
              <Input
                {...rest}
                value={defaultValue}
                rows={3}
                _crengine={_crengine}
                key={dataBind}
                onChange={data => {
                onComponentChange({ name: dataBind, value: data });
              }}
              />
            </div>
);
        })}
    </div>
  );
};

export default InputWidget;
